// https://github.com/pdanpdan/vue-keyboard-trap
import { VueKeyboardTrapDirectivePlugin } from '@pdanpdan/vue-keyboard-trap'

export function install(app) {
  app.use(VueKeyboardTrapDirectivePlugin)
}
